exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header {\n  display: flex;\n  align-items: center; }\n  .header .group {\n    margin-left: auto; }\n\n.input-wrapper {\n  padding-bottom: 25px;\n  border-bottom: 2px solid #ccc;\n  margin-bottom: 25px; }\n\n.ring-loader {\n  display: block;\n  margin: 25px auto 0; }\n\n.spark-popover__content {\n  white-space: normal; }\n\n.spark-popover.popover-active {\n  display: inline-block; }\n\n.allow-domain-content i {\n  margin: 0 6px; }\n\n.allow-domain-content-header-label {\n  display: flex; }\n\n.allow-domain-content-header-label > p {\n  margin-bottom: 2rem; }\n  .allow-domain-content-header-label > p i {\n    margin: 0; }\n  .allow-domain-content-header-label > p li {\n    margin: 0; }\n\n.add-domain-modal > h4 {\n  font-weight: bold; }\n\n.bt-none {\n  border-top: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/manage/domains/ManageDomains/styles.scss
// module id = 1369
// module chunks = 0